/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetOwnedStockParams,
  HTTPValidationError,
  PageWarehouseRead,
  WarehouseRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to get many owned stock.
 * @summary Get Owned Stock
 */
export const getOwnedStock = (
  params?: GetOwnedStockParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageWarehouseRead>({
    url: `/api/owned_stock/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOwnedStockQueryKey = (params?: GetOwnedStockParams) => {
  return ["api", "owned_stock", ...(params ? [params] : [])] as const;
};

export const getGetOwnedStockQueryOptions = <
  TData = Awaited<ReturnType<typeof getOwnedStock>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetOwnedStockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOwnedStock>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOwnedStockQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnedStock>>> = ({
    signal,
  }) => getOwnedStock(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOwnedStock>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOwnedStockQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOwnedStock>>
>;
export type GetOwnedStockQueryError = ErrorType<void | HTTPValidationError>;

export function useGetOwnedStock<
  TData = Awaited<ReturnType<typeof getOwnedStock>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetOwnedStockParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOwnedStock>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnedStock>>,
          TError,
          Awaited<ReturnType<typeof getOwnedStock>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOwnedStock<
  TData = Awaited<ReturnType<typeof getOwnedStock>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetOwnedStockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOwnedStock>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnedStock>>,
          TError,
          Awaited<ReturnType<typeof getOwnedStock>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOwnedStock<
  TData = Awaited<ReturnType<typeof getOwnedStock>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetOwnedStockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOwnedStock>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Owned Stock
 */

export function useGetOwnedStock<
  TData = Awaited<ReturnType<typeof getOwnedStock>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetOwnedStockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOwnedStock>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOwnedStockQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get details for a specific owned stock.
 * @summary Get Owned Stock Details
 */
export const getOwnedStockDetails = (
  warehouseId: number,
  signal?: AbortSignal,
) => {
  return customInstance<WarehouseRead>({
    url: `/api/owned_stock/${warehouseId}`,
    method: "GET",
    signal,
  });
};

export const getGetOwnedStockDetailsQueryKey = (warehouseId?: number) => {
  return ["api", "owned_stock", warehouseId] as const;
};

export const getGetOwnedStockDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOwnedStockDetails>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedStockDetails>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOwnedStockDetailsQueryKey(warehouseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOwnedStockDetails>>
  > = ({ signal }) => getOwnedStockDetails(warehouseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!warehouseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOwnedStockDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOwnedStockDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOwnedStockDetails>>
>;
export type GetOwnedStockDetailsQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetOwnedStockDetails<
  TData = Awaited<ReturnType<typeof getOwnedStockDetails>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedStockDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnedStockDetails>>,
          TError,
          Awaited<ReturnType<typeof getOwnedStockDetails>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOwnedStockDetails<
  TData = Awaited<ReturnType<typeof getOwnedStockDetails>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedStockDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnedStockDetails>>,
          TError,
          Awaited<ReturnType<typeof getOwnedStockDetails>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOwnedStockDetails<
  TData = Awaited<ReturnType<typeof getOwnedStockDetails>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedStockDetails>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Owned Stock Details
 */

export function useGetOwnedStockDetails<
  TData = Awaited<ReturnType<typeof getOwnedStockDetails>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOwnedStockDetails>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOwnedStockDetailsQueryOptions(
    warehouseId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
